/* ---- internal video ---- */
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    this.fullscreenButton = this.querySelector(".internal-video__fullscreen-btn");
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener("mouseup", this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener("mousemove", this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      let t = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), t);
      this.observer.observe(this);
    }
    if (this.fullscreenButton) {
      this.fullscreenButton.addEventListener("click", this.toggleFullscreen.bind(this));
      document.addEventListener("fullscreenchange", this.handleFullscreenChange.bind(this));
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
      let t = this.video.play();
      if (t !== undefined) {
        t.then(() => {
          this.classList.add("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "hidden";
          }
        }).catch(t => {
          this.classList.remove("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "visible";
          }
        });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = true;
      this.classList.add("internal-video--muted");
    }
  }
  updateTimeline() {
    let t = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", t + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag($) {
    $.preventDefault();
    this.dragging = true;
    this.drag($);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag($) {
    if (this.dragging) {
      if ($.touches) {
        $ = $.touches[0];
      }
      this.seekVideo($);
    }
  }
  seekVideo($) {
    let x = this.timeline.getBoundingClientRect();
    let e = $.clientX - x.left;
    let i = e / x.width;
    this.video.currentTime = i * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection($) {
    $.forEach($ => {
      if ($.isIntersecting) {
        for (let e of this.video.querySelectorAll("source[data-src]")) {
          e.setAttribute("src", e.getAttribute("data-src"));
          e.removeAttribute("data-src");
        }
        this.video.load();
        var i = this.video.play();
        if (i !== undefined) {
          i.catch($ => {
            if ($.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn) {
                this.playButton.style.visibility = "visible";
              }
            }
          }).then(() => {
            this.video.play();
          });
        }
        this.observer.disconnect();
      }
    });
  }
  toggleFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      this.requestFullscreen();
    }
  }
  handleFullscreenChange() {
    if (document.fullscreenElement === this) {
      this.classList.add("internal-video--fullscreen");
    } else {
      this.classList.remove("internal-video--fullscreen");
    }
  }
}
customElements.define("internal-video", InternalVideo);
